<template>
  <div class="login-surface login-bg">
    <v-container fluid class="py-10 py-md-14 px-4 px-md-8">
      <v-row dense class="justify-center">
        <v-col cols="12" md="11" lg="10" xl="9">
          <div class="login-shell">
            <v-row no-gutters>
              <!-- Panel Marca / Marketing -->
              <v-col cols="12" md="6" class="d-none d-md-flex pa-0">
                <div class="brand-panel">
                  <div class="d-flex align-center mb-8">
                    <v-img :src="require('@/assets/logo-image-mkt-negativo.svg')" width="220" max-width="220" contain style="filter: invert(1);"></v-img>
                  </div>

                  <div class="mb-8">
                    <div class="text-h5 font-weight-black text-white mb-2" style="line-height: 1.2;">
                      Solicitudes creativas, ordenadas.
                    </div>
                    <div class="text-body-2 text-white" style="opacity: 0.85; max-width: 420px;">
                      Gestiona tickets de marketing con claridad: brief, adjuntos, comentarios y seguimiento en un solo lugar.
                    </div>
                  </div>

                  <div class="feature-list">
                    <div class="feature-item">
                      <v-icon style="font-size: 14px; color: rgba(255,255,255,0.95); margin-right: 10px;">fa:fa-solid fa-wand-magic-sparkles</v-icon>
                      <div>
                        <div class="text-body-2 font-weight-bold text-white">Flujo creativo</div>
                        <div class="text-caption text-white" style="opacity: 0.80;">Solicitudes claras y respuestas rápidas.</div>
                      </div>
                    </div>
                    <div class="feature-item">
                      <v-icon style="font-size: 14px; color: rgba(255,255,255,0.95); margin-right: 10px;">fa:fa-solid fa-paperclip</v-icon>
                      <div>
                        <div class="text-body-2 font-weight-bold text-white">Adjuntos y versiones</div>
                        <div class="text-caption text-white" style="opacity: 0.80;">Todo queda trazable en el ticket.</div>
                      </div>
                    </div>
                    <div class="feature-item">
                      <v-icon style="font-size: 14px; color: rgba(255,255,255,0.95); margin-right: 10px;">fa:fa-solid fa-shield-halved</v-icon>
                      <div>
                        <div class="text-body-2 font-weight-bold text-white">Acceso seguro</div>
                        <div class="text-caption text-white" style="opacity: 0.80;">Inicia con Microsoft o con tu correo.</div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-auto pt-8 text-caption text-white" style="opacity: 0.65;">
                    © IMAGEN CORPORATIVA Y MARKETING • CETEMIN 
                  </div>
                </div>
              </v-col>

              <!-- Panel Formulario -->
              <v-col cols="12" md="6" class="pa-0">
                <div class="form-panel">
                  <div class="d-flex align-center justify-space-between mb-6">
      
                    <v-img class="d-block d-md-none" :src="require('@/assets/logo-image-mkt.svg')" width="200" max-width="200" contain ></v-img>
                    <div class="d-none d-md-block"></div>
                  </div>

                  <component v-bind:is="currentComponent"></component>
                </div>
              </v-col>

            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import FormLoginComponent from "../components/FormLoginComponent.vue";
import FormResetPassComponent from "../components/FormResetPassComponent.vue";
import AlertUserNotFound from "../components/AlertUserNotFound.vue";
export default {
  components: {
    FormLoginComponent,
    FormResetPassComponent,
    AlertUserNotFound
  },

  computed: {
    ...mapState("login", ["currentComponent"]),

  },
  methods: {
    ...mapMutations('login', ['switchComponent']),
  },

  mounted() {
    if (this.$route.query.error) {
      this.switchComponent('AlertUserNotFound')
    }
  }
};
</script>

<style scoped>
.login-surface {
  min-height: 100vh;
  display: flex;
  align-items: center;
}

.login-bg {
  /* Reemplaza bg-pattern (que trae un watermark en la imagen) por un fondo moderno */
  background:
    radial-gradient(900px 420px at 15% 20%, rgba(0, 86, 145, 0.22) 0%, rgba(0, 86, 145, 0) 55%),
    radial-gradient(900px 420px at 85% 35%, rgba(29, 78, 216, 0.18) 0%, rgba(29, 78, 216, 0) 60%),
    linear-gradient(180deg, #0B2336 0%, #071A28 100%);
}

.login-shell {
  position: relative;
  border: 1px solid rgba(238, 242, 247, 0.95);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.14);
  background: #FFFFFF; /* evita “franja ploma” por transparencias */
}

.brand-panel {
  min-height: 600px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 40px 40px;
  background:
    radial-gradient(1000px 520px at 10% 10%, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0) 55%),
    radial-gradient(700px 420px at 75% 30%, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0) 60%),
    linear-gradient(135deg, #002B49 0%, #005691 55%, #1D4ED8 120%);
}

.feature-list {
  display: grid;
  gap: 14px;
  max-width: 520px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  padding: 12px 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.10);
  border: 1px solid rgba(255, 255, 255, 0.14);
}

.form-panel {
  padding: 34px 28px;
  background: #FFFFFF;
}

@media (min-width: 960px) {
  .form-panel {
    padding: 40px 40px;
    min-height: 600px;
  }
}
</style>
